import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import UnstakingStepThreeBg from '../../../../../../../assets/stake/unstaking-step-three-skyrim.png';
import Header from '../../../../../../../components/Stake/header';
import * as skyrimStakeActions from '../../../../../../../actions/skyrim-stake-actions';
import { formatToken } from '../../../../../../../helpers/token-helper';
import SkyrimIcon from '../../../../../../../assets/images/Skyrim.svg';
import Details from '../../../../../../../components/Stake/frame/details';

const UnstakeImmediatelyDetails = () => {
  const dispatch = useDispatch();

  const { amount } = useSelector((state) => state.SKYRIMstake.stake);
  const unstakedValue = `${formatToken(amount)} SKYRIM`;
  const descriptions = [
    'Unstake your tokens immediately for a 2% fee of your current staked amount.',
  ];

  return (
    <>
      <Header
        icon={SkyrimIcon}
        title={`SKYRIM-Unstaking`}
        onClickBack={() => dispatch(skyrimStakeActions.unstakeInformation({ amount }))}
      />
      <Details
        title='You are unstaking:'
        token={unstakedValue}
        buttonClick={() => dispatch(skyrimStakeActions.unstakeImmediatelySend({ amount }))}
        descriptions={descriptions}
        textButton='Unstake Immediately'
        stepBg={UnstakingStepThreeBg}
      />
    </>
  );
};

export default UnstakeImmediatelyDetails;
